// API configuration
// In production, this will use relative paths (same origin)
// In development, it uses the full localhost URL
const getApiBase = () => {
  // Check if we're in production (built app)
  if (process.env.NODE_ENV === 'production') {
    // Use relative path in production
    return '/api';
  }
  // Use environment variable if set, otherwise default to localhost
  return process.env.REACT_APP_API_BASE || 'http://localhost:5001/api';
};

export const API_BASE = getApiBase();
